export async function shareLead(data: { title: string; text: string; url: string }): Promise<boolean> {
  if (navigator.share) {
    try {
      await navigator.share(data);
      return true;
    } catch {
      // User cancelled or not supported
    }
  }
  // Fallback: copy to clipboard
  try {
    await navigator.clipboard.writeText(`${data.text}\n\n${data.url}`);
    return true;
  } catch {
    return false;
  }
}
